/**
 * Button Components
 *
 * Reusable button components with various styles.
 */

import React from "react";
import { commonStyles, gradients, colors } from "../styles";

/**
 * Primary Button with gradient background
 */
export const PrimaryButton = ({
  children,
  onClick,
  disabled = false,
  type = "button",
  style = {},
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    style={{
      ...commonStyles.button,
      background: disabled ? colors.gray300 : gradients.primary,
      color: disabled ? colors.gray500 : colors.white,
      cursor: disabled ? "not-allowed" : "pointer",
      ...style,
    }}
  >
    {children}
  </button>
);

/**
 * Accent Button (orange gradient)
 */
export const AccentButton = ({
  children,
  onClick,
  disabled = false,
  type = "button",
  style = {},
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    style={{
      ...commonStyles.button,
      background: disabled ? "#6c757d" : gradients.accent,
      color: colors.white,
      cursor: disabled ? "not-allowed" : "pointer",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      ...style,
    }}
  >
    {children}
  </button>
);

/**
 * Danger Button (red gradient)
 */
export const DangerButton = ({
  children,
  onClick,
  disabled = false,
  type = "button",
  style = {},
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    style={{
      ...commonStyles.button,
      background: disabled ? colors.gray500 : gradients.danger,
      color: colors.white,
      cursor: disabled ? "not-allowed" : "pointer",
      ...style,
    }}
  >
    {children}
  </button>
);

/**
 * Outline Button (transparent with border)
 */
export const OutlineButton = ({
  children,
  onClick,
  disabled = false,
  type = "button",
  style = {},
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    style={{
      ...commonStyles.button,
      ...commonStyles.buttonOutline,
      opacity: disabled ? 0.6 : 1,
      cursor: disabled ? "not-allowed" : "pointer",
      ...style,
    }}
  >
    {children}
  </button>
);

/**
 * Ghost Button (transparent, for use on dark backgrounds)
 */
export const GhostButton = ({
  children,
  onClick,
  disabled = false,
  type = "button",
  style = {},
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    style={{
      ...commonStyles.button,
      ...commonStyles.buttonGhost,
      cursor: disabled ? "not-allowed" : "pointer",
      ...style,
    }}
  >
    {children}
  </button>
);

/**
 * Secondary Button (gray)
 */
export const SecondaryButton = ({
  children,
  onClick,
  disabled = false,
  type = "button",
  style = {},
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    style={{
      ...commonStyles.button,
      background: "#6c757d",
      color: colors.white,
      cursor: disabled ? "not-allowed" : "pointer",
      ...style,
    }}
  >
    {children}
  </button>
);
